// MLS-DUAL-001 — component_rollup display config (chips shared by tables + fulfillment)
export const ROLLUP_CONFIG = {
  // MLS-STATUS-LABELS-001 (Sep 2026): internal `pending` = not started → "Open"; `on_hold` = paused → "Pending".
  pending: { label: 'Open', cls: 'bg-slate-100 text-slate-600 border-slate-200' },
  in_progress: { label: 'In Progress', cls: 'bg-blue-50 text-blue-700 border-blue-200' },
  tax_pending: { label: 'Tax Open', cls: 'bg-amber-50 text-amber-700 border-amber-200' },
  mls_pending: { label: 'MLS Open', cls: 'bg-cyan-50 text-cyan-700 border-cyan-200' },
  tax_clarification: { label: 'Tax Clarification', cls: 'bg-orange-50 text-orange-700 border-orange-200' },
  mls_clarification: { label: 'MLS Clarification', cls: 'bg-rose-50 text-rose-700 border-rose-200' },
  mls_on_hold: { label: 'MLS Pending', cls: 'bg-amber-50 text-amber-700 border-amber-300' },
  ready_to_complete: { label: 'Ready to Complete', cls: 'bg-emerald-50 text-emerald-700 border-emerald-300' },
  complete: { label: 'Complete', cls: 'bg-green-100 text-green-800 border-green-300' },
};

export const COMPONENT_LABELS = { tax: 'Tax Search', mls: 'MLS Search' };

// MLS-UNIFIED-STATUS-001 — unified, EXCLUSIVE MLS buckets (mirror of backend
// mls_status.MLS_BUCKETS precedence). Tab values carry the `mls_` prefix so
// they never collide with the parent-status tabs of the Tax/Title views.
export const MLS_BUCKET_META = {
  pending_correction: { label: 'Correction Required', cls: 'bg-rose-50 text-rose-700 border-rose-200', tab: 'bg-rose-100 text-rose-700 hover:bg-rose-200' },
  qc_review: { label: 'QC Review', cls: 'bg-violet-50 text-violet-700 border-violet-200', tab: 'bg-violet-100 text-violet-700 hover:bg-violet-200' },
  clarification: { label: 'Clarification', cls: 'bg-orange-50 text-orange-700 border-orange-200', tab: 'bg-orange-100 text-orange-700 hover:bg-orange-200' },
  clarification_received: { label: 'Clarification Received', cls: 'bg-amber-50 text-amber-700 border-amber-200', tab: 'bg-amber-100 text-amber-700 hover:bg-amber-200' },
  mail_away: { label: 'Mail-Away', cls: 'bg-purple-50 text-purple-700 border-purple-200', tab: 'bg-purple-100 text-purple-700 hover:bg-purple-200' },
  mail_away_received: { label: 'Mail-Away Received', cls: 'bg-pink-50 text-pink-700 border-pink-200', tab: 'bg-pink-100 text-pink-700 hover:bg-pink-200' },
  pending: { label: 'Pending', cls: 'bg-amber-50 text-amber-800 border-amber-300', tab: 'bg-indigo-100 text-indigo-700 hover:bg-indigo-200' },
  in_progress: { label: 'In Progress', cls: 'bg-blue-50 text-blue-700 border-blue-200', tab: 'bg-sky-100 text-sky-700 hover:bg-sky-200' },
  open: { label: 'Open', cls: 'bg-slate-100 text-slate-600 border-slate-200', tab: 'bg-blue-100 text-blue-700 hover:bg-blue-200' },
  complete: { label: 'Complete', cls: 'bg-green-100 text-green-800 border-green-300', tab: '' },
};

// Tab order mirrors the standard Operations tab row (In Progress added).
export const MLS_BUCKET_TABS = [
  'open', 'in_progress', 'pending', 'pending_correction', 'mail_away', 'mail_away_received',
  'qc_review', 'clarification', 'clarification_received',
].map((k) => ({ value: `mls_${k}`, bucket: k, label: MLS_BUCKET_META[k].label, color: MLS_BUCKET_META[k].tab }));

export const COMPONENT_STATUS_CONFIG = {
  pending: { label: 'Open', cls: 'bg-slate-100 text-slate-600 border-slate-200' },
  in_progress: { label: 'In Progress', cls: 'bg-blue-50 text-blue-700 border-blue-200' },
  clarification: { label: 'Clarification', cls: 'bg-orange-50 text-orange-700 border-orange-200' },
  on_hold: { label: 'Pending', cls: 'bg-amber-50 text-amber-700 border-amber-300' },
  complete: { label: 'Complete', cls: 'bg-green-100 text-green-800 border-green-300' },
};

// MLS-HOLD-P1 — must stay in lock-step with backend MLS_PENDING_REASONS
export const MLS_PENDING_REASONS = [
  'Awaiting County / Municipality Response',
  'Awaiting Client Information',
  'Awaiting Vendor / External Department',
  'Department Not Responding',
  'Awaiting Requested Records',
  'Other',
];

export const MAILAWAY_ACTIVE_STATUSES = ['pending_send', 'sent', 'confirmed', 'awaiting_response'];

// MLS-MAILAWAY-P2 — must stay in lock-step with backend MLS_MAILAWAY_SECTIONS/METHODS
export const MLS_MAILAWAY_SECTIONS = [
  { value: 'code_violations', label: 'Code Violations' },
  { value: 'open_permits', label: 'Open Permits' },
  { value: 'utility_accounts', label: 'Utilities' },
  { value: 'trash', label: 'Trash' },
  { value: 'other', label: 'Other' },
];
export const MLS_MAILAWAY_METHODS = [
  { value: 'mail', label: 'Mail' },
  { value: 'email', label: 'Email' },
  { value: 'fax', label: 'Fax' },
  { value: 'portal', label: 'Portal' },
];

export const isMlsManagerRole = (role) => {
  const r = (role || '').toLowerCase().replace(/\s+/g, '_').replace(/-/g, '_');
  return r === 'admin' || r === 'tax_search_team_leader';
};

export const isMlsWorkerRole = (role) => {
  const r = (role || '').toLowerCase().replace(/\s+/g, '_').replace(/-/g, '_');
  return ['processor', 'tax_processor', 'admin', 'tax_search_team_leader'].includes(r);
};
